<template>
  <Modal
    v-model="showModal.value"
    title="新建微社区"
    :mask-closable="false"
    @on-ok="saveShequ"
    :loading="true"
  >
    <div class="name-input">
      <Input
        placeholder="请输入微社区名称"
        v-model="shequname"
        @on-blur="debounceSearchBlur"
        @on-focus="debounceSearchFocus"
        @on-change="debounceSearchChange({ refresh: true })"
      />
      <div v-show="showSearchList">
        <Scroll
          class="sConten"
          :on-reach-bottom="handleReachBottom"
          height="210"
          :distance-to-edge="-50"
        >
          <ul>
            <li
              v-for="district in districtList"
              @click="selectItem(district)"
              :key="district.communityId"
              class="house-item"
            >
              <div class="s-title">{{ district.communityName }}</div>
              <div class="s-introduce">{{ district.pathName }}</div>
            </li>
          </ul>
        </Scroll>
        <div class="no-house box house-item" @click="saveShequ">
          <div>
            <div class="s-title">无匹配数据</div>
            <div class="s-introduce">添加（{{ shequname }}）小区</div>
          </div>
          <div class="iconfont icon-tianjia2"></div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    showModal: {
      type: Object,
      default: () => ({ value: false })
    }
  },
  data() {
    return {
      shequname: "", // 新增社区名称
      houseId: "", // 新增社区的id

      pageNum: 1,
      pageSize: 10,
      districtList: [],
      districtComplete: false,

      showSearchList: false // 显示新增微社区的搜索列表
    };
  },
  watch: {},
  computed: {},
  methods: {
    searchBlur() {
      this.showSearchList = false;
    },
    searchFocus() {
      this.showSearchList = true;
    },
    // 无限滚动触底
    handleReachBottom() {
      if (this.districtComplete) return;
      ++this.pageNum;
      this.searchChange();
    },
    // 街道搜索
    searchChange({ refresh = false } = {}) {
      if (refresh) {
        this.pageNum = 1;
        this.districtComplete = false;
        this.districtList.length = 0;
      }
      let url = this.urlobj.getHouse;
      let data = {
        name: this.shequname,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$post(url, data).then(res => {
        if (!res.isSucceed) return this.$Message.error(res.message);

        this.districtList.push(
          ...res.rows.map(item => ({
            communityName: item.name,
            communityId: item.id,
            pathName: item.address
          }))
        );

        if (res.rows.length < this.pageSize) this.districtComplete = true;
      });
    },
    selectItem(district) {
      this.shequname = district.communityName; // 更新显示值
      this.houseId = district.communityId;
    },
    // 新增微社区
    saveShequ() {
      if (!this.shequname) return this.$Message.warning("请输入微社区名称");

      //正则表情
      var reg = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
      if (this.shequname.match(reg) != null)
        return this.$Message.warning("暂不支持输入表情");

      var url = this.urlobj.getOrg();
      this.$post(url, {
        zoneName: this.shequname,
        zoneType: 1,
        housingId: this.houseId
      })
        .then(res => {
          this.$Message.success("添加成功");

          this.showModal.value = false; // 修改引用类型
          this.shequname = ""; // 清空 微支部名称

          // 暴露事件
          this.$emit('on-success')
        })
        .catch(e => {
          this.showModal.value = true;
          this.$Message.error("添加失败");
        })
    }
  },
  created() {
    this.debounceSearchChange = this._.debounce(this.searchChange, 800);
    this.debounceSearchBlur = this._.debounce(this.searchBlur, 800);
    this.debounceSearchFocus = this._.debounce(this.searchFocus, 800);
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
/* 新增微社区弹窗 */
.name-input {
  height: 300px;
}
.sConten {
  width: 100%;
  background: #fff;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}
.house-item {
  padding: 10px;
  border-bottom: 1px solid #eee;
  line-height: 1;
  font-size: 14px;
  color: #666;
}
.house-item:hover {
  cursor: pointer;
  background: #f5f5f5;
}
.s-title {
  margin-bottom: 10px;
}

.no-house {
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eee;
}
.no-house .iconfont {
  font-size: 27px;
  color: #ccc;
}
</style>
